import React, { useEffect, type FC } from 'react';
import { Modal } from 'react-bootstrap';
import { ProductAttributeInterface } from '../../../../Interface/ProductAttribute';
import { getRequest } from '../../../Helper/ApiClient';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareList } from '@fortawesome/sharp-light-svg-icons';
import clsx from 'clsx';

interface INutritionFactImage {
  language: string;
  public_url: string;
  is_default: boolean;
}

type NutritionFactsPropsT = {
  product_attribute: ProductAttributeInterface;
  className?: string;
  show?: boolean;
  onHide?: () => void;
  triggerElement?: React.ReactNode;
} & Omit<React.HTMLAttributes<HTMLDivElement>, 'className'>;

const NutritionFacts: FC<NutritionFactsPropsT> = ({
  product_attribute,
  className,
  show: controlledShow,
  onHide: controlledOnHide,
  triggerElement,
  ...props
}) => {
  const getNutritionFactsRequest = getRequest<INutritionFactImage[]>(
    `/api/onlineshop/product-attributes/${product_attribute.id}/nutrition-facts`,
    undefined,
    { enabled: false }
  );
  const [show, setShow] = React.useState(false);
  const [labelLink, setLabelLink] = React.useState<string>();

  const handleLocaleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setLabelLink(
      getNutritionFactsRequest.data?.find(
        (nutritionFactImage) =>
          nutritionFactImage.language == event.currentTarget.value
      )?.public_url
    );
  };

  const handleClickNfBtn = () => {
    getNutritionFactsRequest.refetch().then(() => setShow(true));
  };

  React.useEffect(() => {
    if (
      getNutritionFactsRequest.isFetched &&
      getNutritionFactsRequest.data &&
      getNutritionFactsRequest.data.length > 0
    ) {
      const default_label = getNutritionFactsRequest.data?.find(
        (nutritionFactImage) => nutritionFactImage.is_default
      )?.public_url;

      if (default_label) {
        setLabelLink(default_label);
      } else {
        setLabelLink(getNutritionFactsRequest.data[0].public_url);
      }
    }
  }, [getNutritionFactsRequest.isFetching]);

  useEffect(() => {
    if (controlledShow) {
      handleClickNfBtn();
    }
  }, [controlledShow]);

  return (
    <div className={clsx('d-flex h-100', className)} {...props}>
      {triggerElement ? (
        triggerElement
      ) : (
        <div onClick={() => handleClickNfBtn()} style={{ cursor: 'pointer' }}>
          <FontAwesomeIcon
            size="lg"
            icon={faSquareList}
            className={'fa-rotate-180'}
          />
        </div>
      )}

      <Modal
        show={show}
        centered
        size="lg"
        onHide={() => {
          setShow(false);
          controlledOnHide?.();
        }}
      >
        <Modal.Header closeButton>
          <select
            style={{ textTransform: 'capitalize' }}
            defaultValue={
              getNutritionFactsRequest.data?.find(
                (nutritionFactImage) => nutritionFactImage.is_default
              )?.language
            }
            onChange={handleLocaleChange}
          >
            {getNutritionFactsRequest.data?.map((nutritionFactImage, key) => (
              <option key={key} value={nutritionFactImage.language}>
                {nutritionFactImage.language}
              </option>
            ))}
          </select>
        </Modal.Header>
        <Modal.Body>
          <div className="w-100 text-center">
            <img
              style={{ maxWidth: '600px', width: 'inherit' }}
              src={labelLink}
              alt="Nutrition-Facts-image"
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default NutritionFacts;
